import { render, staticRenderFns } from "./OpenEnvelopes.vue?vue&type=template&id=503b8f0a"
import script from "./OpenEnvelopes.vue?vue&type=script&lang=js"
export * from "./OpenEnvelopes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports